import _ from 'lodash';

export default {
  props: {
    teacher: Object,
    rootTeacher: Object,
    student: Object,
    enableVideoTranscoder: Boolean,
    discussionRole: {
      type: String,
      validator(discussionRole) {
        return [
          'inactive',
          'observer',
          'teacher',
          'student',
          'anonymous',
        ].includes(discussionRole);
      },
    },
    isProcessingData: {
      type: Boolean,
      default: false,
    },
    playerMode: {
      type: String,
      validator(playerMode) {
        return [
          'bulb',
          'share',
        ].includes(playerMode);
      },
    },
    interaction: {
      type: Object,
      validator(interaction) {
        return (
          _.isObject(interaction)
          && !_.isEmpty(interaction)
        );
      },
    },
    interactionAttempt: Object,
    bulbAttempt: Object,
    bank: Object,
    userType: {
      type: String,
      validator(userType) {
        return [
          'teacher',
          'student',
        ].includes(userType);
      },
    },
    restrictDiscussionCommentsByStudentId: {
      type: [Array, Number],
      default: () => [],
    },
    displayTime: {
      type: Number,
      default: 0,
    },
    maxDisplayTime: {
      type: Number,
      default: 99999999999999999,
    },
  },
  computed: {
    localInteraction: {
      get() {
        return this.interaction;
      },
      set(localInteraction) {
        this.$emit('update:interaction', localInteraction);
      },
    },
    localInteractionAttempt: {
      get() {
        return this.interactionAttempt;
      },
      set(localInteractionAttempt) {
        this.$emit('update:interaction-attempt', localInteractionAttempt);
      },
    },
    localBulbAttempt: {
      get() {
        return this.bulbAttempt;
      },
      set(localBulbAttempt) {
        this.$emit('update:bulb-attempt', localBulbAttempt);
      },
    },
    localIsProcessingData: {
      get() {
        return this.isProcessingData;
      },
      set(localIsProcessingData) {
        this.$emit('update:is-processing-data', localIsProcessingData);
      },
    },
    user() {
      return (this.userType === 'student') ? this.student : this.teacher;
    },
    hideCorrectAnswerIfNotSelected() {
      return !!_.get(this, 'localInteraction.config.hide_correct_answer_if_not_selected');
    },
    hideCorrectAnswerAlways() {
      return (
        !!_.get(this, 'localInteraction.config.hide_correct_answer_always')
        && this.userType !== 'teacher'
      );
    },
    showUnselectedCorrectFeedback() {
      return !!_.get(this, 'localInteraction.config.show_unselected_correct_feedback');
    },
  },
};